import { put, takeLatest, fork, call, takeEvery } from "redux-saga/effects";
import { WebConfig } from "config";
import * as actionTypes from "../actionTypes";
import {
  getInspectionLevelSuccess,
  getInspectionDivisionsSuccess,
  getInspectionClientsSuccess,
  getInspectionServiceLocationsSuccess,
  getInspectionSubLocationsSuccess,
  getInspectionSectionsSuccess,
  getInspectionInspectorsSuccess,
  getInspectionRoomAreaSuccess,
  getInspectionServiceItemsSuccess,
  getInspectionUserDetailSuccess,
  loadTodoError,
  applyInfoFiltersRequestSuccess,
  generateInspectionPdfSuccess,
  getInspectionMasterDataSuccess,
} from "store/actions";
import { ClientInstance } from "utils/axios-instance";
import { getQueryParams } from "utils/helpers";

const API_POINT_URL = WebConfig.serviceUrls.RestApi;
const InspectionEndPoint = WebConfig.ApiUrls.company;

export function* getInspectionLevelRequest() {
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpLevels}?fields=id,name,divisions_count`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionLevelSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionMasterDataRequest(payloadData) {
  const paramData = payloadData?.payload?.dateParams || {};
  const params = getQueryParams(paramData);
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpMasterData}${params}&drop_down=True`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionMasterDataSuccess(response.data.response.Inspection_data));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionDivisionsRequest(payloadData) {
  const paramData = payloadData?.payload || {};
  const params = getQueryParams(paramData, { fields: "id,name" });
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpDivisions}${params}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionDivisionsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionClientsRequest(payloadData) {
  const paramData = payloadData?.payload || {};
  const params = getQueryParams(paramData, { fields: "id,name" });
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpClients}${params}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionClientsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionServiceLocationsRequest(payloadData) {
  const paramData = payloadData?.payload || {};
  const params = getQueryParams(paramData, { fields: "id,name" });
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpServiceLocations}${params}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionServiceLocationsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionSubLocationsRequest(payloadData) {
  const paramData = payloadData?.payload || {};
  const params = getQueryParams(paramData, { fields: "id,name" });
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpSubLocations}${params}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionSubLocationsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionSectionsRequest(payloadData) {
  const paramData = payloadData?.payload || {};
  const params = getQueryParams(paramData, { fields: "id,name" });
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpSections}${params}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionSectionsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionInspectorsRequest() {
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpInspectors}?no_page`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionInspectorsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionRoomAreaRequest() {
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpRoomArea}?no_page`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionRoomAreaSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionServiceItemsRequest() {
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpServiceItems}?no_page`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionServiceItemsSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* getInspectionUserDetailRequest() {
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.inpUserDetail}`
    ).then((response) => {
      return response;
    });
  });
  if (response && response.data.status === 200) {
    yield put(getInspectionUserDetailSuccess(response.data.response));
  }
  if (response && response.data && response.data.status !== 200) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* applyInfoFiltersRequest(data) {
  const paramData = data.payload;
  const params = getQueryParams(paramData);
  const response = yield call(() => {
    return ClientInstance.get(
      `${API_POINT_URL}${InspectionEndPoint.applyInfoFilter}${params}`
    ).then((response) => {
      return response;
    });
  });

  if (response && response.data.status === 200) {
    yield put(applyInfoFiltersRequestSuccess(response.data.response));
  }
  if (
    response &&
    response.data &&
    response.data.status !== 200 &&
    response.data.status !== 401
  ) {
    yield put(loadTodoError(response.data.message.detail));
  }
}

export function* generateInspectionPdfRequest(data) {
  try {
    const paramData = data.payload;
    const params = getQueryParams(paramData);
    const response = yield call(() => {
      return ClientInstance.get(
        `${API_POINT_URL}${InspectionEndPoint.inpPdf}${params}`
      ).then((response) => {
        return response;
      });
    });

    if (response?.data?.status === 200 && response?.data?.response?.url) {
      const pdfUrl = response.data.response.url;

      if (pdfUrl) {
        // Create a temporary link element
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";

        // Append to body, click and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        yield put(generateInspectionPdfSuccess(response.data.response));
      } else {
        yield put(loadTodoError("Failed to generate PDF URL"));
      }
    } else {
      // Handle non-200 status or missing URL
      const errorMessage =
        response?.data?.message?.detail || "Failed to generate PDF";
      yield put(loadTodoError(errorMessage));
    }
  } catch (error) {
    // Handle any unexpected errors
    yield put(
      loadTodoError(error?.message || "An error occurred while generating PDF")
    );
  }
}

function* watchGenerateInspectionPdfRequest() {
  yield takeLatest(
    actionTypes.GenerateInspectionPdfRequested,
    generateInspectionPdfRequest
  );
}

function* watchGetInspectionUserDetailRequest() {
  yield takeLatest(
    actionTypes.InspectionUserDetailRequested,
    getInspectionUserDetailRequest
  );
}

function* watchApplyInfoFiltersRequest() {
  yield takeEvery(
    actionTypes.ApplyInspectionInfoFiltersRequested,
    applyInfoFiltersRequest
  );
}

function* watchGetInspectionLevelRequest() {
  yield takeLatest(
    actionTypes.InspectionLevelRequested,
    getInspectionLevelRequest
  );
}

function* watchGetInspectionMasterDataRequest() {
  yield takeLatest(
    actionTypes.InspectionMasterDataRequested,
    getInspectionMasterDataRequest
  );
}

function* watchGetInspectionDivisionsRequest() {
  yield takeLatest(
    actionTypes.InspectionDivisionRequested,
    getInspectionDivisionsRequest
  );
}

function* watchGetInspectionClientsRequest() {
  yield takeLatest(
    actionTypes.InspectionClientRequested,
    getInspectionClientsRequest
  );
}

function* watchGetInspectionServiceLocationsRequest() {
  yield takeLatest(
    actionTypes.InspectionServiceLocationRequested,
    getInspectionServiceLocationsRequest
  );
}

function* watchGetInspectionSubLocationsRequest() {
  yield takeLatest(
    actionTypes.InspectionSubLocationRequested,
    getInspectionSubLocationsRequest
  );
}

function* watchGetInspectionSectionsRequest() {
  yield takeLatest(
    actionTypes.InspectionSectionRequested,
    getInspectionSectionsRequest
  );
}

function* watchGetInspectionInspectorsRequest() {
  yield takeLatest(
    actionTypes.InspectionInspectorRequested,
    getInspectionInspectorsRequest
  );
}

function* watchGetInspectionRoomAreaRequest() {
  yield takeLatest(
    actionTypes.InspectionRoomAreaRequested,
    getInspectionRoomAreaRequest
  );
}

function* watchGetInspectionServiceItemsRequest() {
  yield takeLatest(
    actionTypes.InspectionServiceItemsRequested,
    getInspectionServiceItemsRequest
  );
}

export const InspectionPerformanceSaga = [
  fork(watchGetInspectionLevelRequest),
  fork(watchGetInspectionMasterDataRequest),
  fork(watchGetInspectionDivisionsRequest),
  fork(watchGetInspectionClientsRequest),
  fork(watchGetInspectionServiceLocationsRequest),
  fork(watchGetInspectionSubLocationsRequest),
  fork(watchGetInspectionSectionsRequest),
  fork(watchGetInspectionInspectorsRequest),
  fork(watchGetInspectionRoomAreaRequest),
  fork(watchGetInspectionServiceItemsRequest),
  fork(watchApplyInfoFiltersRequest),
  fork(watchGetInspectionUserDetailRequest),
  fork(watchGenerateInspectionPdfRequest),
];
